import GenericOAuth from '../oauth';

export const LoftyLogin = ({ apiUrl }: { apiUrl: string }): JSX.Element => {
  return <GenericOAuth apiUrl={apiUrl} provider="lofty" />;
};

export default LoftyLogin;
